
export default {
  props: {
    query: Object
  },
  data: function data() {
    return {};
  },

  computed: {
    sortBtn: function sortBtn() {
      var sort = {};
      if (this.query.order.indexOf('updated_time') !== -1) {
        sort.label = 'updated_time';
      } else if (this.query.order.indexOf('use_times') !== -1) {
        sort.label = 'use_times';
      }
      if (this.query.order.indexOf('-') === 0) {
        sort.value = 'desc';
      } else {
        sort.value = 'asc';
      }
      return [{
        id: 'updated_time',
        value: sort.label === 'updated_time' ? sort.value : '',
        text: '更新时间',
        config: {
          type: sort.label === 'updated_time' ? 'primary' : '',
          icon: function () {
            if (sort.label !== 'updated_time') {
              return 'el-icon-sort';
            }
            return sort.value === 'desc' ? 'el-icon-sort-down' : 'el-icon-sort-up';
          }()
        }
      }, {
        id: 'use_times',
        value: sort.label === 'use_times' ? sort.value : '',
        text: '使用频率',
        config: {
          type: sort.label === 'use_times' ? 'primary' : '',
          icon: function () {
            if (sort.label !== 'use_times') {
              return 'el-icon-sort';
            }
            return sort.value === 'desc' ? 'el-icon-sort-down' : 'el-icon-sort-up';
          }()
        }
      }];
    }
  },
  methods: {
    handleChangeSort: function handleChangeSort(item) {
      if (!item.value) {
        this.query.order = '-' + item.id;
      } else if (item.value === 'desc') {
        this.query.order = item.id;
      } else {
        this.query.order = '-' + item.id;
      }
      this.$emit('search', this.query);
    }
  }
};